module.exports = __webpack_public_path__ + "static/media/companyHub-preview.756713ac.png";